import React, { Component } from 'react';
import { gql } from '@apollo/client';
import { Query } from '@apollo/react-components';
import { Breadcrumb } from 'antd';
import SpinnerError from '$components/library/SpinnerError';
import ReactTable from 'react-table';
import styles from './styles.scss';

const STAFF_PROMO_CODES = gql`
  query StaffPromoCodes {
    staffPromoCodes {
      uuid
      code
      type
      amount
      usesRemaining
    }
  }
`;

class PromoCodes extends Component {
  renderPromoCodes = (promoCodes) => {
    if (promoCodes.length === 0) {
      return <div>No promo codes.</div>;
    }

    return (
      <ReactTable
        columns={[
          {
            id: 'code',
            Header: 'code',
            accessor: 'code',
          },
          {
            id: 'type',
            Header: 'type',
            accessor: 'type',
          },
          {
            id: 'amount',
            Header: 'amount',
            accessor: 'amount',
          },
          {
            id: 'usesRemaining',
            Header: 'usesRemaining',
            accessor: 'usesRemaining',
          },
        ]}
        data={promoCodes}
        className="-striped -highlight"
      />
    );
  };

  render() {
    return (
      <div className={styles.layout}>
        <Breadcrumb>
          <Breadcrumb.Item>Promo Codes</Breadcrumb.Item>
        </Breadcrumb>
        <br />
        <Query query={STAFF_PROMO_CODES}>
          {({ loading, error, data }) => {
            if (loading || error) {
              return <SpinnerError error={error} />;
            }

            const { staffPromoCodes: promoCodes } = data;
            return this.renderPromoCodes(promoCodes);
          }}
        </Query>
      </div>
    );
  }
}

export default PromoCodes;
